<template>
    <b-modal
        :id="modalId"
        class="modal-demo"
        title-class="text-light"
        header-bg-variant="dark"
        header-text-variant="light"
        title-tag="h4"
        size="lg"
        centered
        @hide="hideModal"
    >
        <template #modal-title>
            {{ title }}
        </template>

        <div class="row" dir="rtl">
            <div
                v-for="({ value, type }, label) in submission.content"
                :key="label"
                class="col-12 form-group align-items-start"
                style="display: flex; flex-direction: column;"
            >
                <label :for="label">
                    <b>{{ label }}:</b>
                </label>

                <div v-if="type === 'checkbox'" class="form-check">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        :checked="value"
                        disabled
                    />

                    <div class="ml-2">
                        {{ value ? 'סומן' : 'לא סומן' }}
                    </div>
                </div>

                <file-answer
                    v-else-if="type === 'file' && value"
                    :media-id="value"
                />

                <div v-else-if="type === 'wysiwyg'" v-html="value" />

                <input
                    v-else
                    :value="getValue(value)"
                    type="text"
                    class="form-control"
                    disabled
                />
            </div>
        </div>

        <template #modal-footer>
            <div class="col-12">
                <button
                    type="submit"
                    class="btn btn-success waves-effect waves-light"
                    @click="hideModal"
                >
                    Close
                </button>
            </div>
        </template>
    </b-modal>
</template>

<script>
import FileAnswer from './FileAnswer';

export default {
    components: {
        FileAnswer
    },

    props: {
        modalId: {
            type: String,
            required: false,
            default: 'submission-item-modal'
        },
        submission: {
            type: Object,
            required: true
        }
    },

    computed: {
        title() {
            const { user } = this.submission;

            if (!user) {
                return 'Submission sent by an Anonymous User';
            }

            return `Submission sent by ${user.fullName}`;
        }
    },

    methods: {
        hideModal() {
            this.$bvModal.hide(this.modalId);
        },

        getValue(value) {
            if (Array.isArray(value)) {
                return value.join(', ');
            }

            return value || '-';
        }
    }
};
</script>
